import { BaseService } from "ngx-elvis-ds";

export class BaseWebSocket extends BaseService {

  socket: WebSocket;
  maxSocketLifespan: number = 5 * 1000;

  get status() {
    if (this.socket) {
      if (this.socket.readyState === this.socket.CLOSED || this.socket.readyState === this.socket.CLOSING) {
        return 'offline';
      } else if (this.socket.readyState === this.socket.CONNECTING) {
        return 'connecting';
      } else if (this.socket.readyState === this.socket.OPEN) {
        return 'online';
      }
    } else {
      return 'offline';
    }
  }

  constructor() {
    super();
  }

  connect(address: string) {
    this.socket = new WebSocket(`${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${address}`);
    this.socket.onopen = (e) => { this.onOpen(e); };
    this.socket.onclose = (e) => { this.onClose(e); };
    this.socket.onerror = (e) => { this.onError(e); };
    this.socket.onmessage = (e) => { this.onMessage(e); };

    setTimeout(() => {
      if (this.socket.readyState !== 1) {
        this.socket.close();
      }
    }, this.maxSocketLifespan);
  }

  onSend(message: any) { }
  onError(err: any) { }
  onMessage(event: any) { }
  onOpen(event: any) { }
  onClose(event: any) { }
}
